import { createStore } from 'vuex'
import { user } from './user.js'

export default createStore({
  modules: {
    user: user
  }
})
